import React from 'react';

type StoreCellProps = {
  clusters: { label: string }[];
  storeIds: string[];
};

const StoreCell = ({ clusters = [], storeIds = [] }: StoreCellProps) => {
  if (!clusters?.length && !storeIds?.length) return <span>--</span>;

  return (
    <span>
      {clusters?.length ? clusters.map(({ label }) => label).join(';') : null}
      {storeIds?.length ? storeIds.join(';') : null}
    </span>
  );
};

export default StoreCell;
